<a [href]="params.link" class="item-link" target="_blank">
  {{ params.value }}
  <mat-icon *ngIf="params.showOpenInNewTabIcon" class="open-in-new-icon">
    open_in_new
  </mat-icon>
</a>
